import {defineStore} from "pinia";
import api from "@/plugins/axios";

export const useMonitorStore = defineStore('monitor', {
    actions: {
        async pingReport() {
            const {data} = await api.post(`monitor/ping-report`);
            return data;
        },
        async backupReport() {
            const {data} = await api.post(`monitor/backup-report`);
            return data;
        },
        async runAllBackups() {
            const {data} = await api.post(`backups/run-all`, {}, {timeout: 60000});
            return data;
        },
        async runProjectBackups(projectId) {
            const {data} = await api.post(`backups/run-project`, {projectId}, {timeout: 60000});
            return data;
        },
    }
})
